import React, { useContext } from "react";
import { useNavigate } from "react-router-dom";
import { CombinedContext } from "../../context/combinedContext";
import translations from "../../translations/translations";
import { CheckCircle } from "lucide-react";
import "./businessLanding.css";

const BusinessLanding = () => {
	const { language } = useContext(CombinedContext);
	const navigate = useNavigate();

	return (
		<div className="sf-businesslanding-page">
			{/* HERO */}
			<section className="sf-businesslanding-hero">
				<h1>{translations[language].businessLanding.hero.title}</h1>
				<p>{translations[language].businessLanding.hero.subtitle}</p>

				<div className="sf-businesslanding-hero-actions">
					<button className="btn brand" onClick={() => navigate("/listyourshop")}>
						{translations[language].businessLanding.hero.primaryCta}
					</button>
					{/* <button className="btn outline" onClick={() => navigate("/explore")}>
						{translations[language].businessLanding.hero.secondaryCta}
					</button> */}
				</div>
			</section>

			{/* REAL PROBLEM */}
			<section className="sf-businesslanding-section sf-businesslanding-light">
				<h2>{translations[language].businessLanding.problem.title}</h2>

				<ul className="sf-businesslanding-problem-list">
					{translations[language].businessLanding.problem.items.map((item, idx) => (
						<li key={idx}>{item}</li>
					))}
				</ul>

				<div className="sf-businesslanding-highlight">
					{translations[language].businessLanding.problem.highlight}
				</div>

				<p className="sf-businesslanding-stat">
					{translations[language].businessLanding.problem.stat}
				</p>
			</section>

			{/* HOW SIN FILA HELPS */}
			<section className="sf-businesslanding-section">
				<h2>{translations[language].businessLanding.solution.title}</h2>

				<div className="sf-businesslanding-columns">
					<div className="sf-businesslanding-card">
						<h3>
							{translations[language].businessLanding.solution.business.title}
						</h3>
						<ul>
							{translations[language].businessLanding.solution.business.items.map(
								(item, idx) => (
									<li key={idx}>
										<CheckCircle size={18} /> {item}
									</li>
								)
							)}
						</ul>
					</div>

					<div className="sf-businesslanding-card">
						<h3>
							{translations[language].businessLanding.solution.clients.title}
						</h3>
						<ul>
							{translations[language].businessLanding.solution.clients.items.map(
								(item, idx) => (
									<li key={idx}>
										<CheckCircle size={18} /> {item}
									</li>
								)
							)}
						</ul>
					</div>
				</div>
			</section>

			{/* VISUAL ELEMENTS */}
			<section className="sf-businesslanding-section sf-businesslanding-light">
				<h2>{translations[language].businessLanding.visuals.title}</h2>

				<div className="sf-businesslanding-visual-grid">
					{translations[language].businessLanding.visuals.items.map((item, idx) => (
						<div key={idx} className="sf-businesslanding-visual">
							{item}
						</div>
					))}
				</div>
			</section>

			{/* PRICING */}
			<section className="sf-businesslanding-section">
				<h2>{translations[language].businessLanding.pricing.title}</h2>

				<div className="sf-businesslanding-pricing-card">
					<h3>{translations[language].businessLanding.pricing.mainPrice}</h3>
					<p>{translations[language].businessLanding.pricing.mainDesc}</p>

					<h4>{translations[language].businessLanding.pricing.extraPrice}</h4>
					<p>{translations[language].businessLanding.pricing.extraDesc}</p>

					<ul>
						{translations[language].businessLanding.pricing.includes.map(
							(item, idx) => (
								<li key={idx}>{item}</li>
							)
						)}
					</ul>

					<p className="sf-businesslanding-note">
						{translations[language].businessLanding.pricing.note}
					</p>
				</div>

				<div className="sf-businesslanding-referral">
					{translations[language].businessLanding.pricing.referral}
				</div>
			</section>

			{/* FINAL CTA */}
			<section className="sf-businesslanding-final">
				<h2>{translations[language].businessLanding.final.title}</h2>
				<p>{translations[language].businessLanding.final.subtitle}</p>

				<button
					className="btn brand large"
					onClick={() => navigate("/listyourshop")}
				>
					{translations[language].businessLanding.final.cta}
				</button>

				<div className="sf-businesslanding-stores">
					<p>{translations[language].businessLanding.final.storeText}</p>
					<div className="sf-businesslanding-store-row">
						<div className="sf-businesslanding-store">App Store</div>
						<div className="sf-businesslanding-store">Google Play</div>
					</div>
				</div>
			</section>
		</div>
	);
};

export default BusinessLanding;
